import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

import isoAssets from '../../assets/iso-views/iso9001.pdf';
import isoAssets1 from '../../assets/iso-views/iso27001.pdf';
import FooterStandard from 'components/pages/landing/FooterStandard';
const Iso9001 = () => {
  

  return (
    <div style={{width: '100%',display: 'flex', flexDirection: 'column'}}>
    <div style={{display: 'flex', flexDirection: 'row', width: '100%',height: '88vh', alignItems: 'center', justifyContent: 'center', overflowY: 'hidden' }}>
      <div style={{width: '100%', height: '100%', border: '20px solid white', borderRadius: '10px',  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' // Added a subtle shadow
      }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <div
                style={{
                    border: '1px solid rgba(0, 0, 0, 0.3)',
                    height: '100%',
                    width: '100%'
                }}
            >
              <Viewer viewMode='ViewMode' fileUrl={isoAssets} />
              
            </div>
          </Worker>
          
        </div>
        <div style={{width: '100%',alignItems: 'center', justifyContent: 'center' , height: '100%', border: '20px solid white', borderRadius: '10px',  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' // Added a subtle shadow
          }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <div
                style={{
                    border: '1px solid rgba(0, 0, 0, 0.3)',
                    height: '100%',
                    width: '100%'
                }}
            >
              <Viewer  fileUrl={isoAssets} />
              
            </div>
          </Worker>
          
        </div>     
    </div>
        <FooterStandard/>   
    </div>
  );
};
Iso9001.propTypes = {};
export default Iso9001;
